<template>
<div>
    <div v-if="isLoading" class="center pt-5">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Cargando contenido...</span>
        </div>
    </div>
   <DeptoBase v-else
    :goal="emcorte.meta_semana"
    :progress="emcorte.progress"
    :name="emcorte.nombre"
    :depto="emcorte.depto"
    :days="emcorte.dias_laborados"
    :m3="emcorte.m3_persona"
    :bonus_p="emcorte.bono_persona"
    :bonus_tot="emcorte.bono_depto"
    :asis="emcorte.asistencia"
    :extra="emcorte.$_extra_m3"
    :bonus_prod="emcorte.bono_productividad"
    :bonus_goals="emcorte.bono_metas"
    :descuento="emcorte.descuento_fr"
    />
</div>
</template>


<script>
import DeptoBase from '@/components/DeptoBase';

export default {
    name: 'Emcorte',
    components: {DeptoBase},
    created() {
        this.$store.dispatch("plants/getInfo", {
            department: 'emcorte',
            userCode: this.$route.params.user,
            city: 'veracruz'
        }); 
    },
    computed: {
        isLoading() {
            return this.$store.getters["plants/loading"];
        },
        emcorte() {
        return this.$store.getters["plants/data"];
        }
    }
}
</script>